<div class="partner-wrapper">
  <div class="hero card-glass mb-4">
    <div class="crumb">
      <span class="crumb-current">Espace partenaire</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Partenaires</p>
        <h1>Opérations rapides pour vos clients</h1>
        <p class="lead">Dépôts, retraits et gestion des employés depuis un même espace.</p>
      </div>
      <div class="pill-row">
        <span class="pill">Sécurisé</span>
        <span class="pill">Temps réel</span>
        <span class="pill">Multi-caisses</span>
      </div>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-md-4">
      <div class="action-card card-glass h-100">
        <div class="icon-circle"><i class="bi bi-arrow-down-circle"></i></div>
        <div class="flex-grow-1">
          <h5>Dépôt d'argent</h5>
          <p>Alimentez un compte personnel ou professionnel en quelques secondes.</p>
        </div>
        <button class="btn btn-primary btn-pill" routerLink="/utilisateur/partenaire/depot">Continuer</button>
      </div>
    </div>
    <div class="col-md-4">
      <div class="action-card card-glass h-100">
        <div class="icon-circle"><i class="bi bi-arrow-up-circle"></i></div>
        <div class="flex-grow-1">
          <h5>Retrait</h5>
          <p>Effectuez des retraits sécurisés sur comptes personnels ou pros.</p>
        </div>
        <button class="btn btn-primary btn-pill" routerLink="/utilisateur/partenaire/retrait">Continuer</button>
      </div>
    </div>
    <div class="col-md-4" *ngIf="access">
      <div class="action-card card-glass h-100">
        <div class="icon-circle"><i class="bi bi-people"></i></div>
        <div class="flex-grow-1">
          <h5>Ajouter des employés</h5>
          <p>Créez des accès dédiés pour vos collaborateurs.</p>
        </div>
        <button class="btn btn-primary btn-pill" routerLink="/utilisateur/partenaire/ajouter/employer">Continuer</button>
      </div>
    </div>
  </div>
</div>
